import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { twMerge } from "tailwind-merge"

type EmptyStateProps = {
  icon?: any
  headingText?: string
  bodyText: string
  actions?: any
  size?: "small" | "medium"
}

const sizeLookup: Record<
  string,
  {
    headingClass: string
    bodyClass: string
    icon: {
      height: number
      width: number
    }
  }
> = {
  small: {
    headingClass: "text-base",
    bodyClass: "text-sm",
    icon: {
      width: 24,
      height: 24,
    },
  },
  medium: {
    headingClass: "text-[20px]",
    bodyClass: "text-sm",
    icon: {
      width: 32,
      height: 32,
    },
  },
}

const EmptyState = ({
  icon,
  headingText,
  size = "medium",
  bodyText,
  actions,
}: EmptyStateProps) => {
  const { headingClass, bodyClass, icon: iconProps } = sizeLookup[size]

  return (
    <div className="flex flex-col gap-5 items-center justify-center px-16 py-16">
      {icon && <Icon as={icon} {...iconProps} style={{ opacity: 0.5 }} />}
      <div className="flex flex-col gap-2 items-center text-center mb-2">
        {headingText && (
          <h3 className={twMerge("font-medium", headingClass)}>
            {headingText}
          </h3>
        )}
        <div
          className={twMerge("text-sm text-fg-secondary", bodyClass)}
          style={{ maxWidth: "380px" }}
        >
          {bodyText}
        </div>
      </div>
      {actions && (
        <div className="flex gap-2 items-center justify-between">{actions}</div>
      )}
    </div>
  )
}

export default EmptyState
